import React, {Fragment} from 'react';

export const makeSentence = (items, strong = false) => {
  const itemLength = items.length;
  const itemSentence = items.map((item, index) => {
    if (itemLength === index + 1) {
      return (
        <Fragment key={index}>
          {strong ? (
            <Fragment>
              and <strong>{item}</strong>
            </Fragment>
          ) : (
            <Fragment>and {item}</Fragment>
          )}
        </Fragment>
      );
    } else {
      return (
        <Fragment key={index}>
          {strong ? (
            <Fragment>
              <strong>{item}, </strong>
            </Fragment>
          ) : (
            <Fragment>{item}, </Fragment>
          )}
        </Fragment>
      );
    }
  });

  return itemSentence;
};
